import React from "react";
import ClampLines from "react-clamp-lines";

export const LineEllipsis = ({ text, lines }) => (
  <ClampLines text={text} lines={lines} ellipsis="..." buttons={false} />
);
